var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"-30px"}},[_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":_vm.ModelHeight,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }